import Report from './form';

export default { Report };
